import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Grid from '@mui/material/Grid';
import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import Tooltip from '@mui/material/Tooltip';

import { useTheme } from '@mui/material/styles';
import { createClasses } from '../../utils/stylesUtils';
import paginatorStyles from './Styles/Paginator.Style';
import commonListTableStyles from '../Styles/CommonListTable.Style';
import memberContentStyles from '../Feed/Styles/MemberContent.Style';

type Props = {
  firstPage: Array<Object>,
  nextPage: Array<Object>,
  pageInfo: Object,
  totalCount: number
};

const Paginator = (props: Props) => {
  const {
    firstPage,
    nextPage,
    pageInfo,
    totalCount
  } = props;

  const dispatch = useDispatch();
  const theme = useTheme();
  
  // Create combined styles following the existing pattern
  const classes = createClasses({
    ...paginatorStyles,
    ...commonListTableStyles,
    ...memberContentStyles
  }, theme);

  const changePage = (convoPageNum: number) => {
    // Use the same action type that was used in legacy store for backward compatibility
    dispatch({
      type: 'ACTION_SET_PAGE_NB',
      pageNum: convoPageNum
    });
  };

  return (
    <Grid 
      style={classes.paginateFooter}
      container
    >
      <Grid 
        style={classes.pagePrev}
        item 
        xs={1}
      >
        {
          firstPage && (pageInfo?.pageNum || 1) > 1
          ? <div>
              <Tooltip 
                  aria-label={'First page'}
                  title={'Jump to first page'} 
                >
                <Fab
                  aria-label="firstPage"
                  style={classes.fab}
                  onClick={() => changePage(1)}
                  size="small"
                >
                  <SkipPreviousIcon />
                </Fab>
                </Tooltip>
                <Tooltip 
              aria-label={'Previous page'}
              title={'Previous Page'}
                >
              <Fab
                aria-label="Previous"
                style={classes.fab}
                onClick={() => changePage((pageInfo?.pageNum || 1) - 1)}
                size="small"
              >
                <ArrowLeftIcon style={{ fontSize: '28px'}}/>
              </Fab>
            </Tooltip>
            </div>
          : null
        }
      </Grid>
      <Grid
        style={classes.pageNumber}
        item 
        xs={10} 
      >
        <Button
          style={classes.button}
          disabled
        >{`Page ${pageInfo?.pageNum || 1}/${totalCount && pageInfo?.pageSize ? Math.ceil(totalCount/pageInfo.pageSize) : 1}`}</Button>
      </Grid>

      <Grid 
        style={classes.pageNext}
        item 
        xs={1} 
      >
        {
          nextPage && nextPage.length > 0
          ? <div>
              <Tooltip 
                aria-label={'Next page'}
                title={'Next Page'} 
              >
              <Fab
                aria-label="Next"
                style={classes.fab}
                onClick={() => changePage(pageInfo.pageNum + 1)}
                size="small"
              >
                <ArrowRightIcon style={{ fontSize: '28px'}}/>
              </Fab>
              </Tooltip>
              <Tooltip 
                aria-label={'Jump to last page'}
                title={'Jump to last page'} 
              >
              <Fab
                aria-label="lastPage"
                style={classes.fab}
                onClick={() => changePage(totalCount && pageInfo?.pageSize ? Math.ceil(totalCount/pageInfo.pageSize) : 1)}
                size="small"
              >
                <SkipNextIcon/>
              </Fab>
              </Tooltip>
            </div>
          : null
        }
      </Grid>
    </Grid>
  );
};

export default Paginator;

